
interface HeroProps {
  scrollToSection: (id: string) => void;
}

export default function Hero({ scrollToSection }: HeroProps) {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/cdc6db970bf99cc5a04b8d5645926ff5.jpg"
          alt="Woodworking craftsmanship"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Bespoke Wooden Bowls
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-4 max-w-3xl mx-auto">
          Handcrafted with Care from Locally Sourced Northeast Ohio Wood
        </p>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Each piece is a unique work of art, celebrating the natural beauty of wood and the tradition of fine craftsmanship
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => scrollToSection('products')}
            className="px-8 py-4 bg-amber-700 text-white text-base font-semibold rounded-lg hover:bg-amber-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Explore Our Collection
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer whitespace-nowrap"
          >
            Our Story
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
